/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Consumption cycle lifetime policy for a contract rate.
 */
export type CycleKind = typeof CycleKind[keyof typeof CycleKind];


export const CycleKind = {
  rolling: 'rolling',
  calendar: 'calendar',
} as const;
